import { autorun } from 'mobx';
import { useEffect, useState } from 'react';
import user from 'stores/user';
import { useAccount } from 'wagmi';

function useAppLoading() {
    const { isConnecting, address, isDisconnected, isReconnecting } = useAccount();
    const [userAuthed, setUserAuthed] = useState<boolean>(!!(user.opsUser?.skipInviteBind || user.opsUser?.invitedBy));
    const [appLoading, setAppLoading] = useState<boolean>(true);
    // console.log('useAccount', isConnecting, isDisconnected, isReconnecting, address);
    useEffect(
        () =>
            autorun(() => {
                const isAuthed = address && (user.opsUser?.skipInviteBind || user.opsUser?.invitedBy);
                setUserAuthed(!!isAuthed);
            }),
        [address],
    );

    useEffect(
        () =>
            autorun(() => {
                // appLoading = true when 1. wallet is connecting 2. opsUserFetched is false;
                if ((!isConnecting && !address) || user.opsUserFetched) {
                    setAppLoading(false);
                }
            }),
        [isConnecting, address],
    );

    return [userAuthed, appLoading];
}

export default useAppLoading;
